import Ajaxinate from "fork-ajaxinate";

(() => {
  const Moonbase = window.Moonbase || {};
  Moonbase.Ajaxinate = Ajaxinate;

  // Callback function for anything needed when Ajaxinate renders the next page
  function ajaxinateCallback() {
    if(document.querySelector(".swiper-mobile")) {
      const swipers = document.querySelectorAll(".swiper-mobile");
      swipers.forEach((swiper) => {
        const parameters = JSON.parse(swiper.dataset.swiper);
        new window.Moonbase.Swiper(swiper, parameters);
      });
    }
  }

  new Moonbase.Ajaxinate({
    container: ".ajaxinate",
    pagination: ".paginate-button",
    previousPagination: ".paginate-previous-button",
    loadingText: "Loading...",
    method: "click",
    saveHistory: true,
    loader: true,
    callback: ajaxinateCallback
  });
})();